import { React } from "react";
import "./preloader.cmp.scss";

function Preloader() {
  return <div className="preloader"></div>;
}

export default Preloader;